// src/redux/slices/authSlice.js
import { createSlice } from '@reduxjs/toolkit';
import { encryptToken } from '../../Utlis/Encryption';

const storedEncryptedToken = localStorage.getItem("token");
const storedUser = localStorage.getItem("user");
const storedInviteProfileUpdateToken = localStorage.getItem("inviteProfileUpdateToken");

const initialState = {
  token: storedEncryptedToken || null, // 🔑 encrypted
  user: storedUser && storedUser !== "undefined" ? JSON.parse(storedUser) : null,
  otpData: null, 
  inviteEmail: null,
  resetToken: null, 
  profileUpdateToken: null, 
  inviteProfileUpdateToken: storedInviteProfileUpdateToken || null, // invite flow
  registrationData: null, // 👈 NEW for register API response
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setCredentials: (state, action) => {
      const { token, user } = action.payload;
      if (token) {
        const encryptedToken = encryptToken(token);
        state.token = encryptedToken;
        localStorage.setItem("token", encryptedToken);
      }
      if (user) {
        state.user = user;
        localStorage.setItem("user", JSON.stringify(user));
      }
      console.log("📦 [authSlice] setCredentials triggered");
      console.log("👤 User stored:", user);
    },

    setOtpData: (state, action) => {
      state.otpData = action.payload; // 👈 email + otp info
    },

    // ✅ NEW: specifically handle Register API response
    setRegistrationData: (state, action) => {
      state.registrationData = action.payload; 
      console.log("🆕 Registration Data stored:", action.payload);
    },

    setResetToken: (state, action) => {
      state.resetToken = action.payload; 
    },

    setProfileUpdateToken: (state, action) => {
      state.profileUpdateToken = action.payload;
    },

    setInviteProfileUpdateToken: (state, action) => {
      state.inviteProfileUpdateToken = action.payload;
      localStorage.setItem("inviteProfileUpdateToken", action.payload);
    },

    setInviteEmail: (state, action) => {
      state.inviteEmail = action.payload;
    },

    logout: (state) => {
      state.token = null;
      state.user = null;
      state.otpData = null;
      state.profileUpdateToken = null;
      state.inviteEmail = null;
      state.registrationData = null;
      localStorage.removeItem("token");
      localStorage.removeItem("profileUpdateToken");
      localStorage.removeItem("inviteProfileUpdateToken");  
    }
  },
});

export const { 
  setCredentials, 
  logout, 
  setOtpData, 
  setResetToken, 
  setProfileUpdateToken, 
  setInviteEmail,
  setInviteProfileUpdateToken,
  setRegistrationData, // 👈 export new action
} = authSlice.actions;

export default authSlice.reducer;



// // src/redux/slices/authSlice.js
// import { createSlice } from '@reduxjs/toolkit';
// import { encryptToken } from '../../Utlis/Encryption';

// const storedEncryptedToken = localStorage.getItem("token");
// const storedUser = localStorage.getItem("user");
// const storedInviteProfileUpdateToken = localStorage.getItem("inviteProfileUpdateToken");

// const initialState = {
//   // token: storedEncryptedToken || null,
//   //  user: storedUser ? JSON.parse(storedUser) : null,
//     token: storedEncryptedToken || null, // 🔑 plain string, no parse
//   user: storedUser && storedUser !== "undefined" ? JSON.parse(storedUser) : null, 
//    otpData: null, 
//                inviteEmail: null,

//      resetToken: null, 
//        profileUpdateToken: null, 
//   inviteProfileUpdateToken: storedInviteProfileUpdateToken || null, // invite flow

// };

// const authSlice = createSlice({
//   name: 'auth',
//   initialState,
//   reducers: {
//     setCredentials: (state, action) => {
//       const { token, user } = action.payload;
//       const encryptedToken = encryptToken(token);
//       state.token = encryptedToken;
//         // state.token = token;
//       state.user = user;
//         console.log("📦 [authSlice] setCredentials triggered");
//   // console.log("🔐 Encrypted Token stored:", encryptedToken);
//   console.log("👤 User stored:", user);
//       // console.log("Encrypted token before storing:", encryptedToken);
//       localStorage.setItem("token", encryptedToken);
//       localStorage.setItem("token", encryptedToken);
             
//       localStorage.setItem("user", JSON.stringify(user));
//     },
//       setOtpData: (state, action) => {
//       state.otpData = action.payload; // 👈 email and otp
//     },
//        setResetToken: (state, action) => {
//       state.resetToken = action.payload; // ✅ Set the token
//     },
//         setProfileUpdateToken: (state, action) => {
//       state.profileUpdateToken = action.payload;
//     },
//          setInviteProfileUpdateToken: (state, action) => {
//       state.inviteProfileUpdateToken = action.payload;
//       localStorage.setItem("inviteProfileUpdateToken", action.payload);
//     },
//           setInviteEmail: (state, action) => {   // ✅ new reducer
//       state.inviteEmail = action.payload;
//     },
//     logout: (state) => {
//       state.token = null;
//       state.user = null;
//        state.otpData = null;
//         state.profileUpdateToken = null;
//                           state.inviteEmail = null;
//       localStorage.removeItem("token");
//         localStorage.removeItem("profileUpdateToken");
//   localStorage.removeItem("inviteProfileUpdateToken");  
//     }
//   },
// });

// export const { setCredentials, logout , setOtpData, setResetToken ,setProfileUpdateToken, setInviteEmail,
//      setInviteProfileUpdateToken,
//  } = authSlice.actions;
// export default authSlice.reducer;


